import { create } from 'zustand';
import { NoteFormatResponse } from '@/features/noteFormats';

interface NoteFormatDisplayState {
  activeResult: NoteFormatResponse | null;
  activeDisplayName: string | null;
  isRegenerating: boolean;
  regenerateHandler: (() => void) | null;
  deleteHandler: (() => void) | null;
  generatedFormats: NoteFormatResponse[];
  displayNameMap: Record<string, string>;
  activeTab: string;
  setActiveFormat: (result: NoteFormatResponse, displayName: string) => void;
  clearActiveFormat: () => void;
  setRegenerateHandler: (handler: (() => void) | null) => void;
  setDeleteHandler: (handler: (() => void) | null) => void;
  setIsRegenerating: (value: boolean) => void;
  setGeneratedFormats: (formats: NoteFormatResponse[]) => void;
  setDisplayNameMap: (map: Record<string, string>) => void;
  setActiveTab: (tab: string) => void;
}

const useNoteFormatDisplayStore = create<NoteFormatDisplayState>((set) => ({
  activeResult: null,
  activeDisplayName: null,
  isRegenerating: false,
  regenerateHandler: null,
  deleteHandler: null,
  generatedFormats: [],
  displayNameMap: {},
  activeTab: 'original',
  setActiveFormat: (result, displayName) => set({ activeResult: result, activeDisplayName: displayName }),
  clearActiveFormat: () => set({ activeResult: null, activeDisplayName: null }),
  setRegenerateHandler: (handler) => set({ regenerateHandler: handler }),
  setDeleteHandler: (handler) => set({ deleteHandler: handler }),
  setIsRegenerating: (value) => set({ isRegenerating: value }),
  setGeneratedFormats: (formats) => set({ generatedFormats: formats }),
  setDisplayNameMap: (map) => set({ displayNameMap: map }),
  setActiveTab: (tab) => set({ activeTab: tab }),
}));

export default useNoteFormatDisplayStore;
